import React from "react"
import { setWalletDepositModalOpen } from "../../modules/modals/deposit-withdraw/redux/walletDepositModalSlice"
import { _getDepositAddress } from "../../redux/actions"
import {
  setDepositAddress,
  setSelectedCoinId,
  setDepositData
} from "../../redux/slices/depositSlice"
import { store } from "../../redux/store"
import { hideBackdrop, showBackdrop } from "../backdrop/backdropHelpers"
import { handleWalletNotFound } from "./handleWalletNotFound"
import { } from "../../modules/modals/wallet-loading/helpers/walletLoadingModal"
import { showErrorSnackbar } from "../../modules/snackbar/helpers"
import { FormattedMessage } from "react-intl"

export const handleDeposit = (coinId) => {
  // First, dispatch the action to set the selected coin ID
  store.dispatch(setSelectedCoinId(coinId))

  // Then find the coin data to store along with the ID
  const state = store.getState()
  const currencies = state.currencies.value
  const coinData = currencies.find(currency => currency.id === coinId) || {}

  // Store the coin data for reference in the modal
  store.dispatch(setDepositData(coinData))

  // Now proceed with the API call
  showBackdrop()
  _getDepositAddress(
    {
      coin: coinId
    },
    (data) => {
      if (data.address === null) {
        setTimeout(() => {
          _getDepositAddress(
            {
              coin: coinId
            },
            (data) => {
              hideBackdrop()
              if (data.address) {
                store.dispatch(setDepositAddress(data))
                store.dispatch(setWalletDepositModalOpen(true))
              } else {
                handleWalletNotFound()
              }
            },
            (err) => {
              hideBackdrop()
              handleWalletNotFound()
            }
          )
        }, 15000) // Delay of 15000 milliseconds (15 seconds)
      } else {
        hideBackdrop()
        store.dispatch(setDepositAddress(data))
        store.dispatch(setWalletDepositModalOpen(true))
      }
    },
    (err) => {
      console.log(err)
      if (err && err.data?.errors && !err.data?.errors[0].includes("not_permitted")) {
        showErrorSnackbar({ alertMessage: err.errors[0].length ? (<FormattedMessage id={err.errors[0]} />) : "Failed to get deposit address" })

      } else if (err && err.errors) {
        showErrorSnackbar({ alertMessage: err.errors[0].length ? (<FormattedMessage id={err.errors} />) : "Failed to get deposit address" })
      }
      // toast.error("Failed to get deposit address")
      hideBackdrop()
    }
  )
}
